document.addEventListener('DOMContentLoaded', function () {
  var page = document.querySelector('[data-product-page]');
  if (!page) return;

  var mainImage = document.getElementById('GlowTreeMainImage');
  page.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        mainImage.src = thumb.getAttribute('data-image');
        mainImage.alt = thumb.getAttribute('data-alt') || '';
      }
      page.querySelectorAll('[data-gallery-thumb]').forEach(function (item) { item.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  var quantity = page.querySelector('[data-qty]');
  page.querySelector('[data-qty-minus]')?.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
  page.querySelector('[data-qty-plus]')?.addEventListener('click', function () { quantity.value = Number(quantity.value || 1) + 1; });

  var variantSelect = page.querySelector('[data-variant-select]');
  var variantId = page.querySelector('[data-variant-id]');
  var addButton = page.querySelector('[data-add-to-cart]');
  variantSelect?.addEventListener('change', function () {
    var option = variantSelect.options[variantSelect.selectedIndex];
    variantId.value = option.value;
    page.querySelector('[data-price]').textContent = option.dataset.price;
    page.querySelector('[data-mobile-price]').textContent = option.dataset.price;
    var compare = page.querySelector('[data-compare]');
    if (compare) compare.textContent = option.dataset.compare || '';
    addButton.disabled = false;
    addButton.textContent = 'ADD TO CART';
  });

  page.querySelectorAll('[data-bundle]').forEach(function (choice) {
    choice.addEventListener('change', function () {
      if (!choice.checked) return;
      variantId.value = choice.dataset.variant;
      quantity.value = choice.dataset.quantity;
      page.querySelectorAll('.bundle-box label').forEach(function (label) { label.classList.remove('selected'); });
      choice.closest('label').classList.add('selected');
      addButton.disabled = false;
      addButton.textContent = 'ADD TO CART';
    });
  });
  page.querySelector('[data-bundle]:checked')?.closest('label')?.classList.add('selected');

  var form = page.querySelector('[data-ajax-product-form]');
  var toast = page.querySelector('[data-toast]');
  form?.addEventListener('submit', function (event) {
    event.preventDefault();
    addButton.disabled = true;
    addButton.textContent = 'ADDING…';
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(function () {
        addButton.textContent = 'OPENING YOUR CART…';
        window.location.assign('/cart');
      })
      .catch(function () { addButton.textContent = 'PLEASE TRY AGAIN'; addButton.disabled = false; });
  });

  page.querySelector('[data-mobile-add]')?.addEventListener('click', function () {
    form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () { addButton?.focus(); }, 500);
  });
});
